import { CommApiInstance } from "Utils/CommApiInstance";

const CommuBrdCtgrLstApi = async (
) => {
    return await CommApiInstance.post(`brd/BBO/ctgr_lst`,{
        apiBody:{
        }
    })
    .then((Resp) => Resp.data);
}
export default CommuBrdCtgrLstApi;